import { WEISCHER_INTERSCROLLER, WEISCHER_OVERVIEW, WEISCHER_PREROLL } from "../constants/weischerTypes"
import { filterWeischerAds, getPrerolUrl } from "./weischerHelpers"

const getWeischerData = (weischerAds) => {
    const filteredWeischerAds = filterWeischerAds(weischerAds, [WEISCHER_OVERVIEW, WEISCHER_INTERSCROLLER, WEISCHER_PREROLL])
    const prerollUrl = getPrerolUrl(filteredWeischerAds[WEISCHER_PREROLL])

    return {
        overviewWeischerAds: filteredWeischerAds[WEISCHER_OVERVIEW],
        interscrollerWeischerAds: filteredWeischerAds[WEISCHER_INTERSCROLLER],
        prerollUrl: prerollUrl
    }
}

export default getWeischerData